export class QuestionBankViewReq {
    classId: number;
    subject: number;
    chapter: number;
    marks: number;
    language: number;
    activeOnly?: boolean;
    subjectName?: string;
    constructor(classId: number, subject: number, chapter: number, marks: number, language: number, activeOnly?: boolean, subjectName?: string) {
        this.classId = classId;
        this.subject = subject;
        this.chapter = chapter;
        this.language = language;
        this.marks = marks;
        this.activeOnly = activeOnly;
        this.subjectName = subjectName;
    }
}